module.exports = __webpack_public_path__ + "pic/69.b6cfecb5.png";